export enum ICONS {
  SOLAR_TECHNOLOGY = 'solarTechnologyIcon',
  WIND_TECHNOLOGY = 'windTechnologyIcon',
  BOTH_TECHNOLOGY = 'bothTechnologyIcon',
  GREEN_CHECK = 'greenCheckIcon',
  OPERATIONAL = 'operationalIcon',
  CHEVRON_UP = 'chevronUp',
  CIRCLED_ERROR = 'circledError',
  CIRCLED_WARNING = 'circledWarning',
  WHITE_CHECK_ICON = 'whiteCheckIcon',
  AUTO_EXECUTED_ICON = 'autoExecutedIcon',
  CIRCLE = 'circleIcon',
  CIRCLED_INFO = 'circledInfoIcon',
}

export enum CREDIT_PROFILE {
  INVESTMENT_GRADE = 'INVESTMENT_GRADE',
  NON_INVESTMENT_GRADE = 'NON_INVESTMENT_GRADE',
}

export enum CONTRACT_CREDIT_PROFILE {
    INVESTMENT_GRADE_ENTITY = "INVESTMENT_GRADE_ENTITY",
    PARENTAL_GUARANTEE_FROM_INVESTMENT_ENTITY = "PARENTAL_GUARANTEE_FROM_INVESTMENT_ENTITY",
    PARENTAL_GUARANTEE_FROM_NON_INVESTMENT_ENTITY = "PARENTAL_GUARANTEE_FROM_NON_INVESTMENT_ENTITY",
    LETTER_OF_CREDIT = "LETTER_OF_CREDIT",
    PROJECT_LIEN = "PROJECT_LIEN",
    OTHER = "OTHER",
}

export enum TECHNOLOGY {
  SOLAR = 'SOLAR',
  WIND = 'WIND',
  BOTH = 'BOTH',
}

export enum PRODUCT_TYPE {
  VIRTUAL_PPA = 'VIRTUAL_PPA',
  PHYSICAL_PPA = 'PHYSICAL_PPA',
  RECS = 'RECS',
}

export enum CONTRACT_TYPE {
  NEW_BUILD_VPPA = 'NEW_BUILD_VPPA',
  POST_BUILD_VPPA = 'POST_BUILD_VPPA',
  MINI_POST_BUILD_VPPA_AUTO_EXECUTED = 'MINI_POST_BUILD_VPPA_AUTO_EXECUTED',
  NEW_BUILD_PPA = 'NEW_BUILD_PPA',
  POST_BUILD_PPA = 'POST_BUILD_PPA',
  REC = 'REC',
}

export enum WATCHLIST_ENTITY_TYPE {
  VPPA = 'VPPA',
  PROJECT = 'PROJECT',
}

export enum CASCADE_COMPANY_ID_WATCHLIST {
  CASCADE_COMPANY_ID = '',
}

export enum VPPA_RFQ_STATUS {
  ACTIVE = 'ACTIVE',
  TRADE_PENDING = 'TRADE_PENDING',
  EXISTING_INTEREST = 'EXISTING_INTEREST',
  EXECUTED = 'EXECUTED',
  DELISTED = 'DELISTED',
  DELETED = 'DELETED',
  AWAITING_KEY_METRICS = 'AWAITING_KEY_METRICS',
  INSUFFICIENT_DATA = 'INSUFFICIENT_DATA',
  INTERNAL_PORTFOLIO = 'INTERNAL_PORTFOLIO',
}

export enum NEGOTIATION_STATUS {
  IN_PROGRESS = 'IN_PROGRESS',
  REQUIRES_CONFIRMATION = 'REQUIRES_CONFIRMATION',
  CONFIRMED_AWAITING_BUYER = 'CONFIRMED_AWAITING_BUYER',
  CONFIRMED_AWAITING_SELLER = 'CONFIRMED_AWAITING_SELLER',
  REJECTED = 'REJECTED',
  SUCCESSFUL = 'SUCCESSFUL',
  REVIEW_DRAFT = 'REVIEW_DRAFT',
  IN_PROGRESS_ARTERIA = 'IN_PROGRESS_ARTERIA',
  REVIEW_EXECUTION_CHECKLIST = 'REVIEW_EXECUTION_CHECKLIST',
  READY_FOR_TRADE_EXECUTION = 'READY_FOR_TRADE_EXECUTION',
  PENDING_EXECUTION = 'PENDING_EXECUTION',
  EXECUTED_AWAITING_BUYER = 'EXECUTED_AWAITING_BUYER',
  EXECUTED_AWAITING_SELLER = 'EXECUTED_AWAITING_SELLER',
  EXECUTED = 'EXECUTED',
  EXPIRED = 'EXPIRED',
  BUYER_DELETED = 'BUYER_DELETED',
  SELLER_DELETED = 'SELLER_DELETED',
  FULL_DELETED = 'FULL_DELETED',
  PENDING_EXECUTION_TIMER = 'PENDING_EXECUTION_TIMER',
  TRADED_AWAY = 'TRADED_AWAY',
}

export enum ProfileVisibility {
  BUYER = 'BUYER',
  SELLER = 'SELLER',
  USER_ADMIN = 'USER_ADMIN',
}

export enum PROJECT_OPERATIONAL_STATUS {
  NEW_BUILD = 'NEW_BUILD',
  OPERATIONAL = 'OPERATIONAL',
}

export enum RoutePath {
  SELLER_DASHBOARD = 'dashboard',
  BUYER_DASHBOARD = 'buyer-dashboard',
  MARKET_DEPTH = 'market-depth',
  EXECUTION = 'execution',
  SELLER_ANALYTICS = 'analytics',
  BUYER_ANALYTICS = 'buyer-analytics',
  USER_MANAGEMENT = 'user-management',
  SELLER_RFQ = 'seller-rfq',
  PROJECT_OVERVIEW = 'project',
  ACKNOWLEDGEMENT = 'acknowledgement',
  EXPLORE = 'explore',
  WELCOME = 'welcome',
}

export enum CompanyRole {
  BUYER_ONLY = 'BUYER_ONLY',
  SELLER_ONLY = 'SELLER_ONLY',
  BI_DIRECTIONAL = 'BI_DIRECTIONAL',
  ADVISOR = 'ADVISOR',
  CASCADE_ADMIN = 'CASCADE_ADMIN',
}

export enum PROFILE_RIGHTS {
  EMPTY = '',
  BUYER_VISIBILITY = 'BuyerVisibility',
  SELLER_VISIBILITY = 'SellerVisibility',
  COMPANY_MANAGEMENT = 'CompanyManagement',
  AUTO_EXECUTE = 'AutoExecute',
  BUYER_DASHBOARD_VIEW = 'BuyerDashboardView',
  SELLER_DASHBOARD_VIEW = 'SellerDashboardView',
  MARKET_DEPTH_VIEW = 'MarketDepthView',
  BUYER_ANALYTICS_VIEW = 'BuyerAnalyticsView',
  SELLER_ANALYTICS_VIEW = 'SellerAnalyticsView',
  EXECUTION_VIEW = 'ExecutionView',
  STRUCTURED_CHAT_VIEW = 'StructuredChatView',
  PROJECT_OVERVIEW_VIEW = 'ProjectOverviewView',
  EXPLORE_VIEW = 'ExploreView',
  POST_TRADE_VIEW = 'PostTradeView',
  USER_MANAGEMENT_VIEW = 'UserManagementView',
  LEGAL_VISIBILITY = 'LegalVisibility',
  AUTHORIZED_SIGNATORY_VISIBILITY = 'AuthorizedSignatoryVisibility',
  TRANSACTION_ADVISOR_VISIBILITY = 'TransactionAdvisorVisibility',
  UPSERT_VPPA = 'UpsertVPPA',
  UPSERT_NEGOTIATION = 'UpsertNegotiation',
  ADMIN_VISIBILITY = 'AdminVisibility',
  UPSERT_PROJECT = 'UpsertProject',
  REMAP_SUB_CHANGE = 'RemapSubChange',
  DELETE_PROJECT = 'DeleteProject',
  UPSERT_RFQ = 'UpsertRFQ',
  ADVISOR = 'Advisor',
}

export enum GRAPH_DATA_TYPE {
  HISTORICAL = 'HISTORICAL',
  FORECAST = 'FORECAST',
}

export enum GRAPH_PERIODICITY {
  MONTHLY = 'MONTHLY',
  QUATERLY = 'QUATERLY',
  YEARLY = 'YEARLY',
}

export enum GRAPH_PERIOD_TIME {
  ONE_YEAR = '1',
  THREE_YEAR = '3',
  FIVE_YEAR = '5',
  TEN_YEAR = '10',
}

export enum AGGREGATION_TYPE {
  SUM = 'SUM',
  AVG = 'AVG',
}

export enum GRAPH_SCENARIO {
  BASELINE = 'Baseline',
  HIGH_GAS = 'High Gas',
  LOW_GAS = 'Low Gas'
}

export enum METHOD_EXECUTION {
  RFQ = 'RFQ',
  MINI_POST_BUILD_VPPA_AUTO_EXECUTED = 'MINI_POST_BUILD_VPPA_AUTO_EXECUTED',
}

export enum ICON_COLORS {
  NEW_BUILD_PROJECT_STATUS = '#879ba6',
  POST_BUILD_PROJECT_STATUS = '#a9ff78',
  REC_STATUS = '#7eaaff',
  AUTO_EXECUTED_STATUS = '#ffbf00',
}

export enum RESURETY_REMAP_VERSION {
  LITE = 'LITE',
  BASIC = 'BASIC',
  PRO = 'PRO',
}

export enum FORM_AGREEMENT_TYPE {
  NEW_ISDA_VPPA = 'NEW_ISDA_VPPA',
  EXISTING_ISDA_VPPA = 'EXISTING_ISDA_VPPA',
  STANDALONE_VPPA = 'STANDALONE_VPPA',
  OFF_PLATFORM_REC = 'OFF_PLATFORM_REC',
}

export enum RFQ_APPLICABLE_REC_PROGRAM {
  COMPLIANCE_REC = 'COMPLIANCE_REC',
  GREEN_E_REC = 'GREEN_E_REC',
  NONE = 'NONE',
  ANY = 'ANY',
}

export enum AVERAGE_TYPE {
  ALL_ISOS = 'ALL_ISOS',
  SINGLE_ISO = 'SINGLE_ISO',
}

export enum GOVERNING_AGREEMENT {
  EXISTING_ISDA_MASTER_AGREEMENT = 'EXISTING_ISDA_MASTER_AGREEMENT',
  STANDALONE_VPPA = 'STANDALONE_VPPA',
}

export function getKeyByValue(value: string, enumType: any) {
  return enumType[
    Object.keys(enumType)[Object.values(enumType).indexOf(value as unknown as typeof enumType)]
  ];
}
